import type { NetworkPayload } from "../../../composites";

const customHeaders = {
  "API-Version": "0017",
} as const;

export type CheckDetailPatchPayload = {
  pay_from?: string;
  pay_to?: string;
  amount?: string;
  memo?: string;
  check_date?: string | null;
  check_number?: string;
};

export type CheckDetailPatchResponse = CheckDetailPatchPayload & {
  description?: string | null;
};

const ImageAPI = {
  getTransactionImages: (transactionId: string): NetworkPayload => {
    return {
      url: `transactions/${transactionId}/images`,
      options: {
        method: "GET",
        customHeaders,
      },
    };
  },
  patchCheckDetail: (
    transactionId: string,
    checkDetailUuid: string,
    data: CheckDetailPatchPayload,
  ): NetworkPayload => {
    return {
      url: `transactions/${transactionId}/check-detail/${checkDetailUuid}`,
      options: {
        method: "PATCH",
        payload: data,
      },
    };
  },
};

export default ImageAPI;
